module.exports = __webpack_public_path__ + "static/video_en-6718a1a74566ffcb55e17b375c14b1e0.png";